import jsonp from "../utils/jsonp-util";
import { PASSPORT_ROOT_ADDRESS, XOYO_PLATFORM_ADDRESS, XOYO_URL } from "../constants/urls";

export default class Services {
  //1.金山通行证登录接口;2.手机登录接口(待提供);3.手机验证码接口;4.忘记密码接口;5.注册接口;6.wegame登录接口;7.第三方登录(待确认)


  /**
   * 登录
   * @param params
   * @returns {Promise<ServiceResponse | never>}
   */
  static login(params) {
    return jsonp(PASSPORT_ROOT_ADDRESS + "/login", params).then((response) => {
      if (response.status === 1) {
        return response.data;
      }
      return Promise.reject(response);
    });
  }

  /**
   * 手机验证码登录
   * @param params
   * @returns {Promise<ServiceResponse | never>}
   */
  static loginByCode(params) {
    return jsonp(PASSPORT_ROOT_ADDRESS + "/login_or_register_by_code", params).then((response) => {
      if (response.status === 1) {
        return response.data;
      }
      return Promise.reject(response);
    });
  }

  /**
   * 注册
   * @param params
   * @returns {Promise<ServiceResponse | never>}
   */
  static register(params) {
    return jsonp(PASSPORT_ROOT_ADDRESS + "/register", params).then((response) => {
      if (response.status === 1) {
        return response.data;
      }
      return Promise.reject(response);
    });
  }

  /**
   * wegame登录
   * @param params
   * @returns {Promise<ServiceResponse | never>}
   */
  static getWegameAuthorizeUrl(params) {
    return jsonp(XOYO_PLATFORM_ADDRESS + "/passport/thirdparty_api/get_authorize_url", params).then((response) => {
      if (response.status === 1) {
        return response.data;
      }
      return Promise.reject(response);
    });
  }

  /**
   * 第三方登录
   * 注意:prefer_passport  当同时存在通行证态和第三方登录态，是否优先使用通行证登录态 1是 0否,默认不传是1
   * @param loginType
   * @param preferPassport
   * @returns {Promise<ServiceResponse | never>}
   */
  static getThirdAuthorize(loginType) {
    const preferPassport = window.XPASS.preferPassport;
    return jsonp(XOYO_URL + "/core/thirdlogin/get_auth_url?ts=" +
      new Date().getTime() +
      "&prefer_passport=" + preferPassport + "&callback=__GET_AUTH_URL__&login_type=" +
      loginType +
      "&font_callback=" +
      encodeURIComponent(window.location.href)).then((response) => {
      if (response?.status === 1) {
        return response?.data;
      }
      return Promise.reject(response);
    });
  }

  /**
   * 手机登录-获取验证码
   * @param params
   * @returns {Promise<ServiceResponse | never>}
   */
  static sendCodeByLogin(params) {
    return jsonp(PASSPORT_ROOT_ADDRESS + "/send_code_by_login_or_register", params).then((response) => {
      if (response.status === 1) {
        return response.data;
      }
      return Promise.reject(response);
    });
  }

  /**
   * 获取验证码
   * @param params
   * @returns {Promise<ServiceResponse | never>}
   */
  static sendCode(params) {
    return jsonp(PASSPORT_ROOT_ADDRESS + "/send_code", params).then((response) => {
      if (response.status === 1) {
        return response.data;
      }
      return Promise.reject(response);
    });
  }

  /**
   * 获取金山通行证登录信息
   * @returns {Promise<ServiceResponse | never>}
   */
  static getPassportLoginInfo() {
    return jsonp(PASSPORT_ROOT_ADDRESS + "/get_info").then((response) => {
      if (response.status === 1) {
        return response.data;
      }
      return Promise.reject(response);
    });
  }

  /**
   * 获取第三方登录信息
   * QQ,微信,微博
   * @returns {Promise<ServiceResponse | never>}
   */
  static getThirdLoginInfo() {
    return jsonp(XOYO_URL + "/core/thirdlogin/get_current_user_info").then((response) => {
      if (response.status === 1) {
        return response.data;
      }
      return Promise.reject(response);
    });
  }

  /**
   * 金山通行证登录退出
   * @returns {Promise<ServiceResponse | never>}
   */
  static exitPassport() {
    return jsonp(PASSPORT_ROOT_ADDRESS + "/logout").then((response) => {
      if (response.status === 1) {
        return response.data;
      }
      return Promise.reject(response);
    });
  }

  /**
   * 第三方登录退出
   * @returns {Promise<ServiceResponse | never>}
   */
  static exitThird() {
    return jsonp(XOYO_URL + "/core/thirdlogin/logout").then((response) => {
      if (response.status === 1) {
        return response.data;
      }
      return Promise.reject(response);
    });
  }


}
